import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import {entityOaid, reportYear} from "../../util/util";

let pollution_search = {
  name: 'pollution-search',
  data: () => {
    return {
      report_month: null,
      report_months: [],
      pollutant: 'particulates',
      pollutant_options: [
        {label: '颗粒物', value: 'particulates'},
        {label: 'NOx', value: 'nox'},
        {label: 'SO2', value: 'so2'},
        {label: 'VOCs', value: 'vocs'},
        {label: '氨氮', value: 'ammonia_nitrogen'},
        {label: 'CODcr', value: 'codcr'},
        {label: '总磷', value: 'total_phosphorus'},
        {label: '总氮', value: 'total_nitrogen'}
      ],
      // industry: null,
      // area: null,
      data: [],
      industry_code: [],
      industry_code_option:null,
      industry_code_options: [],
      loading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      }
    }
  },
  mounted () {
    reportYear.esg_report_month().then(result => {
      this.industry_code_options = result.industry_code
    })
    this.getCurrentMonth()
  },
  methods: {
    industryCodeOnChange (value, selectedOptions) {
      this.industry_code = value
    },
    industryCodeFilter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    getCurrentMonth () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()
      if(month==0) this.report_month = (year - 1) + '-' + 12
      else if(month<10) this.report_month = (year - 1) + '-' + '0' + month
      else this.report_month = (year - 1) + '-' + month
      this.report_months = [this.report_month]
    },
    getPollutionSearchData () {
      let self = this
      self.loading = true
      let params = new Map()
      if (self.report_months.length === 0) {
        return
      }
      params.set('report_months', self.report_months)
      params.set('pollutant', self.pollutant)
      if (self.industry_code.length > 0) {
        params.set('industry_code', self.industry_code.slice(-1)[0])
      }
      params.set('pagenum', self.page.currentPage)
      params.set('pagesize', self.page.pageSize)
      console.log('@@@',params);
      httpManager('pollution_license_execution', params, null, null, null)
        .then(response => {
          self.data = []
          if (response.data.data.length > 0) {
            response.data.data.forEach(function (value, index, array) {
              let item = value
              item['location_county'] = item['province'] + '-' + item['district'] + '-' + item['county']
              item['pollutant'] = item[self.pollutant]
            })
            self.data = response.data.data
          }
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getPollutionSearchData()
    },
    searchKeyUp (e) {
      if (e.$event.key === 'Enter') {
        this.getPollutionSearchData()
      }
    },
    clearData () {
      this.data = []
      this.industry_code_option=""
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.getCurrentMonth()
      this.pollutant = 'particulates'
      this.area = null
      this.industry = null
      this.industry_code=[]
    }
  },
  watch: {
    report_month: function () {
      if (!this.report_month) {
        this.getCurrentMonth()
      }
      this.report_months = [this.report_month.slice(0, 7)]
      this.getPollutionSearchData()
    },
    pollutant: function () {
      if (!this.pollutant) {
        this.pollutant = 'particulates'
      }
      this.getPollutionSearchData()
    },
    industry_code: function () {
      this.getPollutionSearchData()
    }
  },
  computed: {
    tableColumn() {
      return [
        {type: 'seq', width: 50},
        {title: this.$t('pollution.original_permit_id'), field: 'original_permit_id'},
        {title: this.$t('pollution.current_permit_id'), field: 'current_permit_id'},
        {title: this.$t('pollution.pollution_unit_name'), field: 'company_name', type: 'html', className: 'click-cell-style', formatter: ({row}) => {
          return '<a target="_blank" href="/entity/'+ row.oaid + '/home">' + row.company_name + '</a>'
        }},
        {title: this.$t('pollution.monthly_emmission'), field: 'pollutant', formatter: ({cellValue}) => { return cellValue ? cellValue.toLocaleString() : '' }},
        {title: this.$t('pollution.national_economy_industry_type'), field: 'industry'},
        {title: this.$t('pollution.location'), field: 'location_county'}
      ]
    }
  }
}
export default pollution_search



// WEBPACK FOOTER //
// ./src/pollution/js/pollution_search.js